const forceLogout = async () => {
  try {
    ['authToken', 'tokenId', 'refreshToken'].forEach(key =>
      localStorage.removeItem(key)
    );
    window.location.href = '/login';
  } catch (error) {
    console.error('Error during automatic logout:', error);
  }
};

export { forceLogout };
